module.exports = __webpack_public_path__ + "img/cvv-image.f703ecc9.svg";